// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_BLUR_BACKGROUND_100 = '20px';
export const SYS_BLUR_BACKGROUND_200 = '40px';
export const SYS_BLUR_BACKGROUND_300 = '60px';
export const SYS_BLUR_BACKGROUND_400 = '80px';
export const SYS_BLUR_CARD = '60px';
//# sourceMappingURL=dimension.generated.js.map